var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExcelIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24414_99130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 9.61914H22.1344V18.0004H36V9.61914Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 18H22.1344V26.3813H36V18Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1344 9.61914H8.29688V18.0004H22.1344V9.61914Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1343 26.3813V18H8.32495V26.3813V27.5906V33.1031C8.32495 34.0031 9.0562 34.7344 9.9562 34.7344H34.3406C35.2406 34.7344 35.9718 34.0031 35.9718 33.1031V26.3813H22.1343Z",
    fill: "#185B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3406 1.26562H22.1062V9.64687H36V2.89688C35.9718 1.99688 35.2406 1.26562 34.3406 1.26562Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1344 1.26562H9.9844C9.0844 1.26562 8.35315 1.99688 8.35315 2.89688V9.61875H22.1625V1.26562H22.1344Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7343 27.1406H1.82808C0.843701 27.1406 0.0280762 26.325 0.0280762 25.3406V10.6594C0.0280762 9.675 0.843701 8.85938 1.82808 8.85938H16.7343C17.7187 8.85938 18.5343 9.675 18.5343 10.6594V25.3406C18.5343 26.325 17.7468 27.1406 16.7343 27.1406Z",
    fill: "#17864C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3907 23.175L10.2938 21.1781C9.8438 20.3906 9.56255 19.8563 9.25317 19.2656H9.22505C8.97192 19.8563 8.7188 20.3906 8.29692 21.1781L7.31255 23.175H5.17505L8.21255 18.0844L5.25942 13.0781H7.42505L8.52192 15.1594C8.85942 15.7781 9.11255 16.2844 9.36567 16.8469H9.42192C9.70317 16.2281 9.90005 15.7781 10.2375 15.1594L11.3344 13.0781H13.4719L10.4625 18L13.5844 23.175H11.3907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.7594 10.4902C18.7594 10.5465 18.7594 10.6027 18.7594 10.659V25.3402C18.7594 26.3246 17.9438 27.1402 16.9594 27.1402H8.55005V28.7434H18.45C19.4344 28.7434 20.25 27.9277 20.25 26.9434V12.2621C20.2782 11.3621 19.6032 10.6027 18.7594 10.4902Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24414_99130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExcelIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excel-icon.1bdaffff40d96ca5b4a45e46729f3f06.svg";